import { isAfter, isBefore } from 'date-fns'
import { optionalStringSchema } from 'utils/zodHelpers'
import { z } from 'zod'

export const editUnitSchema = z
  .object({
    unitSlug: z.string(),
    name: z
      .string({ message: 'Name is required' })
      .min(1)
      .max(65, { message: 'Name must be less than 65 characters' }),
    builtDate: z.date().nullable(),
    description: z.string(),
    erpID: optionalStringSchema,
    area: optionalStringSchema,
    areaDescription: optionalStringSchema,
    selectedGrouping: z.string().optional(),
    retirementDate: z.date().nullable(),
  })
  .superRefine((data, ctx) => {
    if (
      data.builtDate !== null &&
      data.retirementDate !== null &&
      isAfter(data.builtDate, data.retirementDate)
    ) {
      ctx.addIssue({
        code: 'invalid_type',
        path: ['builtDate'],
        message: 'Built date must be before retirement date',
        expected: 'date',
      })
    }
    if (
      data.retirementDate !== null &&
      isBefore(data.retirementDate, new Date())
    ) {
      ctx.addIssue({
        code: 'invalid_type',
        path: ['retirementDate'],
        message: 'Retirement date must be after today',
        expected: 'date',
      })
    }
    if (
      data.retirementDate !== null &&
      data.builtDate !== null &&
      isBefore(data.retirementDate, data.builtDate)
    ) {
      ctx.addIssue({
        code: 'invalid_type',
        path: ['retirementDate'],
        message: 'Retirement date must be after built date',
        expected: 'date',
      })
    }
  })

export type EditUnitSchema = z.infer<typeof editUnitSchema>

export const defaultValues: EditUnitSchema = {
  unitSlug: '',
  name: '',
  builtDate: null,
  description: '',
  retirementDate: null,
  erpID: '',
  area: '',
  areaDescription: '',
  selectedGrouping: '',
}
